import { toast } from "@risalabs_frontend_org/oasis-ui-kit";
import { useEffect, useState } from "react";
import { Button, TextInput } from "risa-oasis-ui_v2";
import { ToastMessages } from "../components/toasts/toastMessages";
import { useAuthConfig } from "../config/AuthConfigContext";
import MailIcon from "../svg/mail";
import RisaLogoWhite from "../svg/risa-logo-white";
import { sendMagicLinkViaEmail } from "./magicLinkAuth";

const MagicLinkLogin = () => {
  const [userEmail, setUserEmail] = useState<string>("");
  const [error, setError] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isEmailSent, setIsEmailSent] = useState<boolean>(false);
  const config = useAuthConfig();

  const isValidEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  useEffect(() => {
    if (userEmail && !isValidEmail(userEmail)) {
      setError("Please enter a valid email address");
    } else {
      setError("");
    }
  }, [userEmail]);

  const sendMagicLink = async () => {
    setIsLoading(true);
    const isMailSent = await sendMagicLinkViaEmail(userEmail);
    if (isMailSent) {
      toast.success(ToastMessages.EMAIL_LINK_SENT_SUCCESS);
      setIsEmailSent(true);
    } else {
      toast.error(ToastMessages.EMAIL_LINK_SENT_FAILURE);
      setIsEmailSent(false);
    }
    setIsLoading(false);
  };

  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        backgroundColor: "#000000",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          display: "flex",
          height: "100%",
          width: "100%",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "2.5rem",
          paddingBottom: "8vh",
        }}
      >
        <div>
          <RisaLogoWhite width="120" height="42" />
        </div>
        <div
          style={{
            width: "25%",
            minWidth: "320px",
            maxWidth: "420px",
            borderRadius: "0.5rem",
            backgroundColor: "#ffffff",
            padding: "0.75rem",
          }}
        >
          <div className="magic-link--container flex h-auto w-full flex-col items-center justify-center gap-3 p-4">
            <div className="welcome-text mb-2 text-center text-large font-bold">
              Welcome!
            </div>
            {!isEmailSent ? (
              <>
                <div className="email-container w-full">
                  <TextInput
                    id={"user_email"}
                    label={"Email Address"}
                    required
                    onChange={(e: any) => setUserEmail(e.value)}
                    error={error}
                  />
                </div>
                <div className="email-link-button mt-2 w-full">
                  <Button
                    disabled={isLoading || !isValidEmail(userEmail)}
                    children={isLoading ? "Sending..." : "Send Link"}
                    onClick={sendMagicLink}
                    buttonType={"primary"}
                    size={"medium"}
                  />
                </div>
              </>
            ) : (
              <>
                <div className="email-sent-message--container flex flex-col items-center gap-2">
                  <div className="mail-icon">
                    <MailIcon height="3rem" width="3rem" fillColor="#0056d6" />
                  </div>
                  <div className="mesage-header text-center text-h10 font-semibold">
                    Check your inbox!
                  </div>
                  <div className="message-text text-center text-small text-primaryGray-4">
                    We've sent a magic link to your email. <br /> Click the link
                    in your mailbox to sign in.
                  </div>
                  <div className="message-sub-text text-center text-xs italic text-primaryGray-8">
                    (Make sure to check your spam or promotions folder if you
                    don't see it soon.)
                  </div>
                  <div className="message-no-mail-received mt-1 text-center text-tiny text-primaryGray-4">
                    Didn't receive the email? &nbsp; &nbsp;
                    <span
                      className="cursor-pointer text-tiny font-semibold text-tertiaryBlue-4 hover:underline"
                      onClick={() => setIsEmailSent(false)}
                    >
                      Resend Email
                    </span>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div style={{ textAlign: "center", color: "#ffffff" }}>
            Need Help? <span>Contact Us</span>
          </div>
          {config.version && (
            <div
              style={{
                marginTop: "0.5rem",
                textAlign: "center",
                fontSize: "0.75rem",
                color: "#9ca3af",
              }}
            >
              Version : {config.version}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MagicLinkLogin;
